import egyptHolidaysList from "../data/egypt-holidays.json";

const holidayMap = new Map(
  egyptHolidaysList.map((h) => [h.date, h.name]),
);

/**
 * Check if a date is an Egypt public holiday.
 * @param {string} dateStr - Date in YYYY-MM-DD format
 * @returns {boolean}
 */
export const isEgyptHoliday = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return false;
  const normalized = dateStr.trim().split("T")[0];
  return holidayMap.has(normalized);
};

/**
 * Get the name of an Egypt public holiday for a date, or null.
 * @param {string} dateStr - Date in YYYY-MM-DD format
 * @returns {string|null}
 */
export const getEgyptHolidayName = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return null;
  const normalized = dateStr.trim().split("T")[0];
  return holidayMap.get(normalized) ?? null;
};

/**
 * Check if a day should be shown as a holiday (weekend Fri/Sat or Egypt public holiday).
 * @param {string} dateStr - Date in YYYY-MM-DD format
 * @param {string} dayName - Day name e.g. "Friday", "Saturday"
 * @returns {boolean}
 */
export const isHoliday = (dateStr, dayName) => {
  const isWeekend =
    dayName === "Friday" || dayName === "Saturday";
  return isWeekend || isEgyptHoliday(dateStr);
};
